export const Messages = {
  moduleDisable:
    "This modules can only be used if your account has been activated by an administrator.",
  become_a_seller: "Request has been sent to the administration",
};
